<template>
  <createContent/>
</template>

<script>
import createContent from '@/components/_managetransferrole/_update/updateTag.vue'
export default {
  components: {
    createContent
  }
}
</script>
